/* eslint-disable  @typescript-eslint/no-explicit-any */

function SuccessIcon({ width = 400, height = 400, ...props }: any) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        {...props}
      >
        <path
          d="M326.608 128.781h-2.977v-81.57A47.21 47.21 0 00276.42 0H103.601a47.21 47.21 0 00-47.21 47.21v447.502a47.21 47.21 0 0047.21 47.21H276.42a47.21 47.21 0 0047.21-47.21V186.844h2.978z"
          fill="#3f3d56"
        />
        <path
          d="M278.325 12.283h-22.558a16.75 16.75 0 01-15.509 23.076h-99.005a16.75 16.75 0 01-15.508-23.076h-21.07a35.256 35.256 0 00-35.257 35.256v446.845a35.256 35.256 0 0035.257 35.256h173.65a35.256 35.256 0 0035.256-35.256V47.539a35.256 35.256 0 00-35.256-35.256z"
          fill="#fff"
        />
        <path d="M382 542H1a1 1 0 010-2h381a1 1 0 010 2z" fill="#cbcbcb" />
        <circle
          data-name="Ellipse 44"
          cx={191.5}
          cy={261.2336}
          r={84.4462}
          fill="currentColor"
        />
        <path
          data-name="Path 395"
          d="M375.024 432.947a8.758 8.758 0 01-5.269-1.75l-.094-.071-19.846-15.182a8.82 8.82 0 1110.732-13.998l12.854 9.857 30.377-39.629a8.816 8.816 0 0112.36-1.633l.002.002-.188.262.193-.262a8.826 8.826 0 011.63 12.363l-35.728 46.592a8.821 8.821 0 01-7.015 3.439z"
          transform="translate(-191.892 -139.5)"
          fill="#fff"
        />
        <path
          d="M694.245 550.3a26.263 26.263 0 013.606-4.595 28.581 28.581 0 011.774-1.674 28.142 28.142 0 0146.402 16.007c4.124-15.252-6.612-30.276-17.406-41.815-10.8-11.536-23.143-24.192-23.081-39.999.03-8.796 4.333-16.642 10.829-22.46.2-.176.4-.352.605-.522a41.071 41.071 0 0128.288-9.859c19.2 1.029 35.963 13.932 47.605 29.238 18.739 24.627 26.95 59.197 13.831 87.231-11.539 24.657-36.148 39.298-61.265 51.07q-5.26 2.465-10.5 4.782c-.023.006-.048.023-.072.03-.168.073-.336.147-.494.223l-2.157.95.331.217 1.033.668c-.358-.216-.712-.427-1.07-.644-.107-.065-.22-.127-.325-.193-12.336-7.402-24.844-15.232-33.366-26.788-8.838-11.997-12.392-29.183-4.568-41.867z"
          fill="#f1f1f1"
        />
        <path
          d="M776.548 522.436a69.818 69.818 0 015.375 19.53 60.624 60.624 0 01-.73 18.013 77.675 77.675 0 01-15.578 33.322 111.792 111.792 0 01-20.182 19.62q-5.26 2.466-10.5 4.783c-.023.006-.049.023-.072.03-.168.073-.336.147-.494.223l-2.156.95.33.217 1.033.668c-.358-.216-.712-.427-1.07-.644-.106-.065-.22-.127-.325-.193a61.796 61.796 0 00-11.208-55.646 62.325 62.325 0 00-23.12-17.604 28.547 28.547 0 011.774-1.674 64.62 64.62 0 019.903 5.655 63.317 63.317 0 0123.959 31.74 64.735 64.735 0 011.405 36.188c.619-.405 1.24-.82 1.845-1.233 11.492-7.75 22.083-17.058 30.06-28.471a72.261 72.261 0 0012.822-32.585c1.53-12.834-1.682-25.454-7.412-36.905a151.257 151.257 0 00-23.696-33.67 171.872 171.872 0 00-31.776-27.322 1.236 1.236 0 01-.366-1.664 1.051 1.051 0 01.605-.522.915.915 0 01.78.158c1.44.96 2.868 1.93 4.279 2.929a173.822 173.822 0 0131.765 29.016c9.03 10.555 17.25 22.281 22.75 35.091z"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 44"
          cx={525.04172}
          cy={21.27646}
          r={17.93406}
          fill="#f1f1f1"
        />
        <circle
          data-name="Ellipse 44"
          cx={748.04172}
          cy={268.27646}
          r={10.93406}
          fill="#f1f1f1"
        />
        <circle
          data-name="Ellipse 44"
          cx={428.04172}
          cy={298.27646}
          r={10.93406}
          fill="#f1f1f1"
        />
        <path d="M434.215 621h381a1 1 0 100-2h-381a1 1 0 000 2z" fill="#cbcbcb" />
        <path
          d="M773.17 96.635a14.652 14.652 0 00-28.137-7.426l-30.917 35.444 9.072 25.337 31.093-41.415a14.573 14.573 0 0018.889-11.94z"
          fill="#ffb7b7"
        />
        <path
          fill="#3f3d56"
          d="M645.013 234.549L747.642 125.02 733.799 103.012 605.076 211.876 645.013 234.549z"
        />
        <circle cx={622.10766} cy={132} r={36} fill="#2f2e41" />
        <path
          d="M625.001 111.663a75.485 75.485 0 0127.464-17.759c6.638-2.46 13.864-3.979 20.805-2.582 6.94 1.396 13.504 6.198 15.44 13.008 1.583 5.568-.052 11.563-2.509 16.805-2.457 5.242-5.737 10.103-7.724 15.54a35.468 35.468 0 0035.689 47.562c-6.82.915-13.106 4.12-19.771 5.825-6.666 1.706-14.533 1.59-19.486-3.185-5.241-5.053-5.346-13.267-5.093-20.543l1.13-32.445c.192-5.515.356-11.207-1.633-16.355-1.989-5.148-6.716-9.656-12.234-9.609-4.183.036-7.885 2.57-11.239 5.068-3.354 2.499-6.904 5.165-11.07 5.536-4.167.372-8.924-2.711-8.612-6.882z"
          fill="#2f2e41"
        />
        <path
          d="M485.377 373.723a14.652 14.652 0 01-11.039-26.925l31.1-35.284 26.305 5.683-36.997 36.239a14.573 14.573 0 01-9.369 20.287z"
          fill="#ffb7b7"
        />
        <path
          fill="#3f3d56"
          d="M587.698 247.405L510.183 344.705 486.555 333.857 577.665 192.012 587.698 247.405z"
        />
        <path
          fill="#ffb7b7"
          d="M525.848 541.211L507.374 540.921 509.596 603.887 525.845 603.887 525.848 541.211z"
        />
        <path
          d="M529.99 598.582l-32.001-.001h-.001a20.395 20.395 0 00-20.394 20.393v.663l52.395.002z"
          fill="#2f2e41"
        />
        <path
          fill="#ffb7b7"
          d="M648.165 524.511L627.984 537.467 668.352 586.032 682.026 577.253 648.165 524.511z"
        />
        <path
          d="M682.647 570.55l-26.929 17.288a20.395 20.395 0 00-6.143 28.18l.358.557 44.09-28.307z"
          fill="#2f2e41"
        />
        <path
          d="M655.355 332.24s-44.84-148.927-59.25-150.94-37.628 38.213-37.628 38.213c-30.103 38.408-61.144 162.821-61.144 162.821s51.746 3.238 89.573 23.364 82.468-1.02 82.468-1.02z"
          fill="#3f3d56"
        />
        <path
          d="M655.355 332.24s-44.84-148.927-59.25-150.94-31.731 38.621-31.731 38.621c-15 62-67.041 162.413-67.041 162.413s51.746 3.238 89.573 23.364 82.468-1.02 82.468-1.02z"
          opacity={0.1}
          style={{
            isolation: "isolate",
          }}
        />
        <path
          fill="#2f2e41"
          d="M618.567 287.682L618.567 362.517 627.374 470.921 671.374 552.921 650.374 567.921 590.374 489.921 566.643 412.472 529.374 583.921 501.374 581.921 520.82 344.21 557.721 277.3 618.567 287.682z"
        />
        <path
          d="M573.358 215.3c-14 14-1 29-1 29l-16 36 63 17 22.016-98.379-15-16c-30-1-30.016-1.621-30.016-1.621-5.257 5.144-23 34-23 34z"
          fill="#1286A4"
        />
        <path
          d="M643.91 188.73a26.884 26.884 0 00-37.776 5.913c-15.838 22.052-30.483 57.66-10.305 102.071 32.399 71.31 60.593 107.815 72.055 107.81a4.56 4.56 0 001.473-.23c7.055-2.394 17.256-14.333 19.103-24.853.66-3.766.504-9.01-4-12.612-12.935-10.347-36.158-42.562-43.402-84.964-4.003-23.43 3.76-44.772 10.978-58.55a26.88 26.88 0 00-7.777-34.33z"
          fill="#3f3d56"
        />
        <circle
          cx={803.14042}
          cy={280.71068}
          r={26.50012}
          transform="rotate(-28.663 434.183 586.507)"
          fill="#ffb7b7"
        />
        <path
          d="M573.98 139.207h38.265l.393-5.494 1.962 5.494h5.892l.777-10.888 3.889 10.888h11.4v-.54a28.624 28.624 0 00-28.591-28.592h-5.395a28.624 28.624 0 00-28.592 28.593z"
          fill="#2f2e41"
        />
        <path
          d="M630.778 158.954l16.33-5.298V114h-30.845l.764.762c10.625 10.611 22.441 48.257 13.75 44.192z"
          fill="#2f2e41"
        />
      </svg>
    );
  }
  
  export default SuccessIcon;
  